import { render, staticRenderFns } from "./LenderHighCost.vue?vue&type=template&id=4b317a61&scoped=true"
import script from "./LenderHighCost.vue?vue&type=script&lang=js"
export * from "./LenderHighCost.vue?vue&type=script&lang=js"
import style0 from "./LenderHighCost.vue?vue&type=style&index=0&id=4b317a61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b317a61",
  null
  
)

export default component.exports